/**
 * Short list of providers to avoid increasing bundle size.
 * @see https://www.npmjs.com/package/email-providers common.json
 * + fastmail.com
 */
export const FREE_EMAIL_PROVIDERS: string[] = [
    'facebook.com',
    'yahoo.com',
    'qq.com',
    'live.com',
    'msn.com',
    'outlook.com',
    'example.com',
    'go.com',
    'aliyun.com',
    'aol.com',
    'free.fr',
    '163.com',
    'yandex.ru',
    'indiatimes.com',
    'alibaba.com',
    'about.com',
    'geocities.com',
    'naver.com',
    'netscape.com',
    'yahoo.co.jp',
    'earthlink.net',
    'sky.com',
    'zoho.com',
    'angelfire.com',
    'uol.com.br',
    'mail.ru',
    'spb.ru',
    'globo.com',
    'yandex.com',
    'gmail.com',
    'medscape.com',
    'space.com',
    'discovery.com',
    't-online.de',
    'mac.com',
    'homestead.com',
    'icloud.com',
    'lycos.com',
    'altavista.com',
    'web.id',
    'comcast.net',
    'nus.edu.sg',
    'rambler.ru',
    'pp.ua',
    'ancestry.com',
    'berlin.de',
    'sapo.pt',
    'msk.ru',
    'law.com',
    'libero.it',
    'bt.com',
    'techspot.com',
    'daum.net',
    'test.com',
    'icq.com',
    'kansascity.com',
    'india.com',
    'hotmail.com',
    'docomo.ne.jp',
    'me.com',
    'orange.fr',
    'wanadoo.fr',
    'sina.cn',
    'fortunecity.com',
    'onet.pl',
    'att.net',
    'canada.com',
    'proton.me',
    'web.de',
    'terra.com.br',
    'skynet.be',
    'excite.com',
    'wp.pl',
    'compuserve.com',
    'zp.ua',
    'ig.com.br',
    'yourdomain.com',
    'detik.com',
    'excite.co.jp',
    'ya.ru',
    'mindspring.com',
    'gmx.net',
    'freeserve.co.uk',
    'shaw.ca',
    'xoom.com',
    'care2.com',
    'test.de',
    'interia.pl',
    'rr.com',
    'virgilio.it',
    'sina.com',
    'ntlworld.com',
    'tiscali.it',
    'chez.com',
    'seznam.cz',
    'sympatico.ca',
    'arcor.de',
    'yam.com',
    'gazeta.pl',
    'geek.com',
    'r7.com',
    'freenet.de',
    'rcn.com',
    'cox.net',
    'blueyonder.co.uk',
    'telenet.be',
    'virginmedia.com',
    'tom.com',
    'hotbot.com',
    'rogers.com',
    'btinternet.com',
    'sfr.fr',
    'catholic.org',
    'iinet.net.au',
    'ozemail.com.au',
    'ireland.com',
    'chat.ru',
    'doityourself.com',
    'verizon.net',
    'virgin.net',
    'erols.com',
    'o2.co.uk',
    'albawaba.com',
    'lycos.co.uk',
    'lycos.de',
    'protonmail.com',
    'sanook.com',
    'pochta.ru',
    'home.nl',
    'aol.co.uk',
    'mail.com',
    'www.com',
    'online.de',
    'casino.com',
    'terra.es',
    'nate.com',
    'centrum.cz',
    '21cn.com',
    'bluewin.ch',
    'planet.nl',
    '126.com',
    'rin.ru',
    'walla.co.il',
    'name.com',
    'i.ua',
    'voila.fr',
    'charter.net',
    'poste.it',
    'netcom.com',
    'mydomain.com',
    'parrot.com',
    'hidemyass.com',
    'myway.com',
    'chello.nl',
    'freeuk.com',
    'tiscali.co.uk',
    'sify.com',
    'club-internet.fr',
    'telus.net',
    'sci.fi',
    'ivillage.com',
    'metacrawler.com',
    'blackplanet.com',
    'dailypioneer.com',
    'mail-tester.com',
    'optusnet.com.au',
    'hamptonroads.com',
    'onmilwaukee.com',
    'alice.it',
    'sdf.org',
    'iespana.es',
    'lycos.es',
    'unican.es',
    'tpg.com.au',
    'sweb.cz',
    'frontier.com',
    'lycos.nl',
    'looksmart.com',
    'bigpond.com',
    'freeyellow.com',
    'hey.com',
    'prodigy.net',
    'webindia123.com',
    'pobox.com',
    'i.am',
    'gmx.com',
    'kiwibox.com',
    'anonymize.com',
    'oath.com',
    'crosswinds.net',
    'wanadoo.es',
    'eircom.net',
    'frontiernet.net',
    'islamonline.net',
    'dejanews.com',
    'bugmenot.com',
    '10minutemail.com',
    'saudia.com',
    'hetnet.nl',
    'foxmail.com',
    'cogeco.ca',
    'iol.it',
    'neuf.fr',
    'pacbell.net',
    'aim.com',
    'newmail.ru',
    'terra.com',
    'depechemode.com',
    'yahoo.com.tw',
    'concentric.net',
    'mail2web.com',
    'temp-mail.org',
    'netins.net',
    'hot.ee',
    'mailinator.com',
    'ukr.net',
    'yahoo.jp',
    'sprynet.com',
    'idirect.com',
    'bigfoot.com',
    'netspace.net.au',
    'yahoofs.com',
    'yeah.net',
    'lycos.it',
    'masrawy.com',
    'iprimus.com.au',
    'supereva.it',
    'inbox.com',
    'she.com',
    'netzero.net',
    'yahoo.co.uk',
    'o2.pl',
    'elvis.com',
    'spray.se',
    'yahoo.de',
    'go.ro',
    'montevideo.com.uy',
    'scubadiving.com',
    'juno.com',
    'bolt.com',
    'zonnet.nl',
    'pe.hu',
    'attbi.com',
    'talktalk.co.uk',
    'swissinfo.org',
    'mailbox.org',
    'dynu.net',
    'bellsouth.net',
    'hushmail.com',
    'fr.nf',
    'gmx.de',
    'au.ru',
    'gportal.hu',
    'guerrillamail.com',
    'seanet.com',
    'msn.co.uk',
    'bigpond.net.au',
    'adelphia.net',
    'yahoo.fr',
    'c3.hu',
    'telstra.com',
    'incredimail.com',
    'interfree.it',
    'zip.net',
    'starmedia.com',
    'dmv.com',
    'wow.com',
    'forthnet.gr',
    'land.ru',
    'tds.net',
    '4mg.com',
    'usa.com',
    'fastmail.fm',
    'bright.net',
    'thirdage.com',
    'tin.it',
    'backpackers.com',
    'ananzi.co.za',
    'webjump.com',
    'singnet.com.sg',
    'dnsmadeeasy.com',
    'wowway.com',
    'btconnect.com',
    'bangkok.com',
    'sp.nl',
    'terra.cl',
    'spacewar.com',
    'cableone.net',
    'talkcity.com',
    'blogos.com',
    'sbcglobal.net',
    'yahoo.com.cn',
    'lawyer.com',
    '37.com',
    'c2i.net',
    'optimum.net',
    'oi.com.br',
    'iwon.com',
    'nyc.com',
    'roadrunner.com',
    'cu.cc',
    'airmail.net',
    'westnet.com.au',
    'aeiou.pt',
    'doctor.com',
    'yopmail.com',
    'barcelona.com',
    'ny.com',
    'qwest.net',
    'cs.com',
    '3ammagazine.com',
    'korea.com',
    'pipeline.com',
    'btopenworld.com',
    'games.com',
    'mchsi.com',
    'hispavista.com',
    'aver.com',
    'uk.to',
    'singpost.com',
    'dropzone.com',
    'front.ru',
    'yahoo.com.br',
    'everyone.net',
    'terra.com.ar',
    'toolsource.com',
    'ptd.net',
    'abv.bg',
    'windstream.net',
    'charm.net',
    'fuse.net',
    'yahoo.ca',
    'hotmail.ru',
    'onlinehome.de',
    'qwestoffice.net',
    'dog.com',
    'fastmail.com',
];
